import { ClientActionDispatcher } from "duck/ui/chat/actions/ClientActionDispatcher";
import { useStreamingChat } from "duck/ui/chat/hooks";
import { ChatProviderProps } from "duck/ui/chat/types";

import { ChatContext } from "./useChatContext";

export const ChatContextProvider = ({ children }: ChatProviderProps) => {
  const value = useStreamingChat();

  return (
    <ChatContext.Provider value={value}>
      <ClientActionDispatcher actions={value.pendingClientActions} />
      {children}
    </ChatContext.Provider>
  );
};
